import { render, staticRenderFns } from "./FormTicket.vue?vue&type=template&id=7fda5eec&"
import script from "./FormTicket.vue?vue&type=script&lang=ts&"
export * from "./FormTicket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports